import { render, staticRenderFns } from "./invoiceReports.vue?vue&type=template&id=71233916&"
import script from "./invoiceReports.vue?vue&type=script&lang=js&"
export * from "./invoiceReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports